<div class="w-full h-lvh overflow-hidden">
  <router-outlet />
</div>

<app-ng-progress />

@if(_globalProgressSpinnerService.loading$ | async){
<app-progress-spinner />
}

<p-toast position="top-center" life="5000" />

@if (_chatbotService.show$ |async) {
<app-chatbot />
}

<!-- Chatbot -->
@if (showChatbot) {
<div
  class="fixed bottom-0.5 right-0.5 sm:bottom-4 sm:right-4 z-30 p-2 bg-light-150 rounded-full shadow-lg cursor-pointer"
>
  <img
    src="assets/images/icons8-message-bot-96-blue.png"
    class="h-10 w-10 sm:h-14 sm:w-14 mb:w-16 mb:h-16"
    alt="chatbot"
    (mouseenter)="popoverChatbot.show($event)"
    (mouseleave)="popoverChatbot.hide()"
    (click)="onChatbotClick()"
  />
</div>
}

<p-popover #popoverChatbot>
  <p class="w-56 text-light-0 text-base">
    Use our smart assistant to get answers to your questions about the property
    investment process, and more.
  </p>
</p-popover>
